import axios from 'axios'

export default {
    getEmployees: () => axios.get('admin/rrhh/employees'),
    getEmployeesFiltered: (filters) => axios.post('admin/rrhh/filtered-employees', filters),
    getEmployeesFilteredWithPayroll: (filters) => axios.post('admin/rrhh/filtered-payroll-employees', filters),
    getEmployee: (employee_id) => axios.get('admin/rrhh/'+employee_id+'/employee'),
    getPositions: () => axios.get('admin/rrhh/job-positions'),
    getEmployers: () => axios.get('admin/rrhh/employers'),
    getBosses: () => axios.get('admin/rrhh/bosses'),
    getBanks: () => axios.get('admin/rrhh/banks'),
    getCollaborators: () => axios.get('admin/rrhh/active-collaborators'),

    getPeriods: () => axios.get('/admin/rrhh/periods'),
    getMonthPeriods: () => axios.get('/admin/rrhh/month-periods'),
    getEmployeePeriods: (initial_date) => axios.post('/admin/rrhh/employee-periods', {initial_date: initial_date}),
    getVacations: (filters) => axios.post('/admin/rrhh/vacations', filters),
    deleteVacations: (employee_id, vacation_id, period) => axios.post('/admin/rrhh/delete-vacations', {employee_id: employee_id, vacation_id: vacation_id, period: period}),

    storeEmployee: (name, employer_id, employee_position_id) => axios.post('admin/rrhh/employees/store', {name: name, employer_id: employer_id, employee_position_id: employee_position_id}),
    updateEmployee: (data) => axios.post('admin/rrhh/employees/update', data),
    restoreEmployee: (data) => axios.post('admin/rrhh/employees/restore', data),
    disableEmployee: (data) => axios.post('admin/rrhh/employees/disable', data),
    deleteEmployee: (data) => axios.post('admin/rrhh/employees/delete', data),
    calculateEmployee: (data) => axios.post('admin/rrhh/employees/calculate', data),
    tabulatorEmployee: (daily_salary, round) => axios.post('admin/rrhh/employees/tabulator', {daily_salary: daily_salary, round: round}),
    imssEmployee: (daily_salary, work_age, total_work_days) => axios.post('admin/rrhh/employees/imss', {daily_salary: daily_salary, work_age: work_age, total_work_days: total_work_days}),

    importEmployees: (data) => axios.post('admin/rrhh/employees/import', data),
    exportEmployees: (employer_id) => axios.post('admin/rrhh/employees/export', {employer_id: employer_id}),

    getDocuments: (employee_id) => axios.get(`admin/rrhh/${employee_id}/documents`),
    uploadEmployeesDocument: (data) => axios.post('admin/rrhh/employees/upload-document', data, { headers: { 'Content-Type': 'multipart/form-data' }}),

    storeAbsence: (data) => axios.post('admin/rrhh/absences/store', data),
    deleteAbsence: (employee_id, date) => axios.post('admin/rrhh/absences/delete', {employee_id: employee_id, date: date}),
    updateInfonavit: (data) => axios.post('admin/rrhh/infonavit/update', data),
    updateFonacot: (data) => axios.post('admin/rrhh/fonacot/update', data),
    updateBono: (data) => axios.post('admin/rrhh/bono/update', data),

    downloadDocument : (employee, type) => axios.post('admin/rrhh/contracts/download', {employee: employee, type: type}),

    storePayroll: (employee, period, type) => axios.post('admin/rrhh/payrolls/store', {employee: employee, period: period, type: type}),
    exportPayroll: (employees, period, type) => axios.post('admin/rrhh/payrolls/export', {employees: employees, period: period, type: type}),

    getEmployeeByToken: (token) => axios.post('admin/rrhh/employee-by-token', {token: token}),
    getContracts: (token) => axios.get(`/admin/rrhh/${token}/contracts`),
    sendContract: (data) => axios.post('admin/rrhh/employees/send-contract', data),

    signContractProcess : (employee, contract_type, firmaBase64, ip) => axios.post('admin/rrhh/employees/sign-contract', {employee: employee, contract_type: contract_type, firma: firmaBase64, ip: ip}),
}